module.exports = __webpack_public_path__ + "media/images/center-icon-90ba3ca4.png";